import Vue from "vue";

import {
  SlidesPerPageInterface,
  CarouselOrientation,
  CarouselTransition,
} from "./CarouselInterface";

const CarouselProp = Vue.extend({
  props: {
    slidesPerPage: {
      type: [Number, Object as () => SlidesPerPageInterface],
      default: 1,
    },

    responsive: {
      type: Boolean,
      default: true,
    },

    orientation: {
      type: [Number, () => CarouselOrientation],
      default: CarouselOrientation.HORIZONTAL,
    },

    transition: {
      type: [Number, () => CarouselTransition],
      default: CarouselTransition.SLIDE,
    },

    interval: {
      type: Number,
      default: 5000,
    },

    draggable: {
      type: Boolean,
      default: true,
    },

    showDots: {
      type: Boolean,
      default: true,
    },

    showArrows: {
      type: Boolean,
      default: true,
    },

    initialSlide: {
      type: Number,
      default: 0,
    },

    stopOnHover: {
      type: Boolean,
      default: true,
    },

    wheelable: {
      type: Boolean,
      default: true,
    },

    /**
     * TODO: Add this to the interface
     */

    swipeable: {
      type: Boolean,
      default: true,
    },

    autoHeight: {
      type: Boolean,
      default: false,
    },
  },
});

export default CarouselProp;
